import { render, staticRenderFns } from "./CreateAffiliateRequest.vue?vue&type=template&id=0f44ef39"
import script from "./CreateAffiliateRequest.vue?vue&type=script&lang=ts"
export * from "./CreateAffiliateRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports